import http from "@/libs/http";
const coache = {
  /**审批培训班- 系统管理员、青少司 */
  classApprove: ApproveVO => {
    return http.post(http.formatUrl("class/approve"), ApproveVO);
  },
  /**批量审批培训班- 系统管理员、青少司 */
  classApproveBatch: BatchApproveVO => {
    return http.post(http.formatUrl("class/approve/batch"), BatchApproveVO);
  },
  /**删除培训班 - 系统管理员、省、操作员*/
  classDelete: TrainingClassId => {
    return http.post(http.formatUrl("class/delete"), TrainingClassId);
  },
  /**查看培训班- 系统管理员、省、操作员*/
  classInfo: TrainingClassId => {
    return http.get(http.formatUrl("class/info"), TrainingClassId);
  },
  /**新建培训班- 系统管理员、省、操作员*/
  classInsert: TrainingClassVO => {
    return http.post(http.formatUrl("class/insert"), TrainingClassVO);
  },
  /**查询培训班分页列表 - 系统管理员、省、操作员*/
  classPagelist: ClassPageListVO => {
    return http.get(http.formatUrl("class/pagelist"), ClassPageListVO);
  },
  /**撤销已提交的培训班- 系统管理员、项目中心、省*/
  classRevoke: TrainingClassId => {
    return http.post(http.formatUrl("class/revoke"), TrainingClassId);
  },
  /**提交培训班- 系统管理员、项目中心、省**/
  classSubmit: TrainingClassId => {
    return http.post(http.formatUrl("class/submit"), TrainingClassId);
  },
  /**批量提交培训班- 系统管理员、项目中心、省**/
  classSubmitBatch: BatchTrainingClassId => {
    return http.post(http.formatUrl("class/submit/batch"), BatchTrainingClassId);
  },
  /**更新培训班- 系统管理员、省、操作员*/
  classUpdate: TrainingClassVO => {
    return http.post(http.formatUrl("class/update"), TrainingClassVO);
  }
};
export default coache;
